import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/public/auth/token',
    method: 'post',
    data: data
  })
}

export function register(data) {
  return request({
    url: '/public/auth/register',
    method: 'post',
    data: data
  })
}

export function forgotPassword(data) {
  return request({
    url: '/public/auth/forgot-password',
    method: 'post',
    data: data
  })
}

export function resetPassword(data) {
  return request({
    url: '/public/auth/reset-password',
    method: 'post',
    data: data
  })
}

export function sendCode(data) {
  return request({
    url: '/public/auth/send-code',
    method: 'post',
    data: data
  })
}

export function sendRegisterInvite(data) {
  return request({
    url: '/auth/send-register-invite',
    method: 'post',
    data: data
  })
}

export function changePassword(data) {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data: data
  })
}

export function updateInfo(data) {
  return request({
    url: '/auth/update-info',
    method: 'post',
    data: data
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function deactivate() {
  return request({
    url: '/auth/deactivate',
    method: 'post'
  })
}

export function getMe() {
  return request({
    url: '/auth/me',
    method: 'get'
  })
}

export function addFault(data) {
  return request({
    url: '/fault/add',
    method: 'post',
    data: data
  })
}

export function getFaultNotify(params) {
  return request({
    url: '/fault/notify',
    method: 'get',
    params: params
  })
}

export function getFaultListBySn(params) {
  return request({
    url: '/fault/list/by-sn',
    method: 'get',
    params: params
  })
}

export function getFaultList(params) {
  return request({
    url: '/fault/list',
    method: 'get',
    params: params
  })
}

export function getFaultDetail(params) {
  return request({
    url: '/fault/detail',
    method: 'get',
    params: params
  })
}

export function updateFaultStatus(data) {
  return request({
    url: '/fault/update-status',
    method: 'post',
    data: data
  })
}

export function reopenFault(data) {
  return request({
    url: '/fault/reopen',
    method: 'post',
    data: data
  })
}

export function getFaultCount(params) {
  return request({
    url: '/fault/count',
    method: 'get',
    params: params
  })
}

export function getAnswerList(params) {
  return request({
    url: '/answer/list',
    method: 'get',
    params: params
  })
}

export function addAnswer(data) {
  return request({
    url: '/answer/add',
    method: 'post',
    data: data
  })
}

export function updateAnswer(data) {
  return request({
    url: '/answer/update',
    method: 'post',
    data: data
  })
}

export function getAdminFaultList(params) {
  return request({
    url: '/admin/fault/list',
    method: 'get',
    params: params
  })
}

export function getAdminFaultDetail(params) {
  return request({
    url: '/admin/fault/detail',
    method: 'get',
    params: params
  })
}

export function updateAdminFaultStatus(data) {
  return request({
    url: '/admin/fault/update-status',
    method: 'post',
    data: data
  })
}

export function adminFaultRootCause(data) {
  return request({
    url: '/admin/fault/root-cause',
    method: 'post',
    data: data
  })
}

export function getAdminFaultUploadInfo(params) {
  return request({
    url: '/admin/fault/upload-info',
    method: 'get',
    params: params
  })
}

export function exportAdminFaultUpload(data) {
  return request({
    url: '/admin/fault/export-upload',
    method: 'post',
    data: data
  })
}

export function exportAdminFaultEventLog(data) {
  return request({
    url: '/admin/fault/export-event-log',
    method: 'post',
    data: data
  })
}

export function getAdminFaultAgentBindingList(params) {
  return request({
    url: '/admin/fault/agent-binding-list',
    method: 'get',
    params: params
  })
}

export function updateAdminFaultAgent(data) {
  return request({
    url: '/admin/fault/update-agent',
    method: 'put',
    data: data
  })
}

export function getAdminFaultSnSummary(params) {
  return request({
    url: '/admin/fault/sn-summary',
    method: 'get',
    params: params
  })
}

export function addAdminFaultSnRemark(data) {
  return request({
    url: '/admin/fault/sn-remark',
    method: 'post',
    data: data
  })
}

export function deleteAdminFaultSnRemark(params) {
  return request({
    url: '/admin/fault/sn-remark',
    method: 'delete',
    params: params
  })
}

export function getAdminAnswerList(params) {
  return request({
    url: '/admin/answer/list',
    method: 'get',
    params: params
  })
}

export function addAdminAnswer(data) {
  return request({
    url: '/admin/answer/add',
    method: 'post',
    data: data
  })
}

export function adminAnswerUploadInfo(data) {
  return request({
    url: '/admin/answer/upload-info',
    method: 'post',
    data: data,
    params: data
  })
}
export function adminAgentGroupUnbind(params) {
  return request({
    url: '/admin/agent/group/sn/unbind',
    method: 'delete',
    params: params
  })
}

export function getAdminReportFaultList(params) {
  return request({
    url: '/admin/report/fault/list',
    method: 'get',
    params: params
  })
}

export function addAdminReportFault(data) {
  return request({
    url: '/admin/report/fault/add',
    method: 'post',
    data: data
  })
}

export function updateAdminReportFault(data) {
  return request({
    url: '/admin/report/fault/update',
    method: 'put',
    data: data
  })
}

export function deleteAdminReportFault(params) {
  return request({
    url: '/admin/report/fault/delete',
    method: 'delete',
    params: params
  })
}

export function updateAdminReportFaultOrder(data) {
  return request({
    url: '/admin/report/fault/update-order',
    method: 'put',
    data: data
  })
}

export function getAdminReportFaultDataList(params) {
  return request({
    url: '/admin/report/fault/data/list',
    method: 'get',
    params: params
  })
}

export function exportAdminReportFaultData(data) {
  return request({
    url: '/admin/report/fault/data/export',
    method: 'post',
    data: data
  })
}

export function getAdminReportTableList(params) {
  return request({
    url: '/admin/report/table/query/list',
    method: 'get',
    params: params
  })
}

export function getAdminReportHeadList(params) {
  return request({
    url: '/admin/report/table/report/head/list',
    method: 'get',
    params: params
  })
}

export function updateAdminReportTableBatch(data) {
  return request({
    url: '/admin/report/table/update/batch',
    method: 'post',
    data: data
  })
}

export function getAdminUserList(params) {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params: params
  })
}

export function getAdminUserListByRole(params) {
  return request({
    url: '/admin/user/list-by-role',
    method: 'get',
    params: params
  })
}

export function getAdminUserDetail(params) {
  return request({
    url: '/admin/user/detail',
    method: 'get',
    params: params
  })
}

export function updateAdminUserStatus(data) {
  return request({
    url: '/admin/user/update-status',
    method: 'put',
    data: data
  })
}

export function adminUserAssignRole(data) {
  return request({
    url: '/admin/user/assign-role',
    method: 'post',
    data: data
  })
}

export function adminUserRemoveRole(data) {
  return request({
    url: '/admin/user/remove-role',
    method: 'post',
    data: data
  })
}

export function getAdminRoleList(params) {
  return request({
    url: '/admin/role/list',
    method: 'get',
    params: params
  })
}

export function getAdminAgentList(params) {
  return request({
    url: '/admin/agent/list',
    method: 'get',
    params: params
  })
}

export function getAdminAgentAssignableUsers(params) {
  return request({
    url: '/admin/agent/assignable-users',
    method: 'get',
    params: params
  })
}

export function getAdminAgentAccessibleList(params) {
  return request({
    url: '/admin/agent/accessible-list',
    method: 'get',
    params: params
  })
}

export function addAdminAgent(data) {
  return request({
    url: '/admin/agent/add',
    method: 'post',
    data: data
  })
}

export function updateAdminAgent(data, params) {
  return request({
    url: '/admin/agent/update',
    method: 'put',
    data: data,
    params: params
  })
}

export function deleteAdminAgent(params) {
  return request({
    url: '/admin/agent/delete',
    method: 'delete',
    params: params
  })
}

export function getAdminAgentGroupList(params) {
  return request({
    url: '/admin/agent/group/list',
    method: 'get',
    params: params
  })
}

export function getAccessibleList(params) {
  return request({
    url: '/admin/agent/group/accessible-list',
    method: 'get',
    params: params
  })
}

export function addAdminAgentGroup(data) {
  return request({
    url: '/admin/agent/group',
    method: 'post',
    data: data
  })
}

export function updateAdminAgentGroup(data, params) {
  return request({
    url: '/admin/agent/group',
    method: 'put',
    data: data,
    params: params
  })
}

export function deleteAdminAgentGroup(params) {
  return request({
    url: '/admin/agent/group',
    method: 'delete',
    params: params
  })
}

export function getAdminAgentCodeList(params) {
  return request({
    url: '/admin/agent/code/list',
    method: 'get',
    params: params
  })
}

export function getAdminAgentCodes(params) {
  return request({
    url: '/admin/agent/codes',
    method: 'get',
    params: params
  })
}

export function addAdminAgentCode(data) {
  return request({
    url: '/admin/agent/code',
    method: 'post',
    data: data
  })
}
export function assignAdminAgentGroupSn(data) {
  return request({
    url: '/admin/agent/group/sn/assign',
    method: 'post',
    data: data
  })
}

export function updateAdminAgentCode(data,id) {
  return request({
    url: '/admin/agent/code?id='+id,
    method: 'put',
    data: data
  })
}

export function deleteAdminAgentCode(params) {
  return request({
    url: '/admin/agent/code',
    method: 'delete',
    params: params
  })
}

export function uploadFile(data) {
  return request({
    headers: {
      'Content-Type': 'multipart/form-data;'
    },
    url: '/file/upload',
    method: 'post',
    data: data
  })
}